import {Injectable} from '@angular/core';
import {LayoutService} from '../../secure/layout/layout.service';
import {PrepaidServicesStatusInfo} from 'web-angular-client';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionService
{
    private prepaidServicesStatusInfo: PrepaidServicesStatusInfo;

    constructor(protected layoutService: LayoutService)
    {
        this.layoutService.prepaidServicesStatusInfo.subscribe((prepaidServicesStatusInfo: PrepaidServicesStatusInfo) =>
        {
            this.prepaidServicesStatusInfo = prepaidServicesStatusInfo;
        });
    }

    get isSubscriptionValid(): boolean
    {
        return this.prepaidServicesStatusInfo ? (this.prepaidServicesStatusInfo.subscriptionFeePaid || this.prepaidServicesStatusInfo.gracePeriodValid) : false;
    }
}